import { h } from "preact";
import { Swatch } from "../../helpers/icons";
import { formatSwatchPrice, isRugSwatch } from "../../helpers/rugSwatches";

export default function ProductOptionRequestSwatch({ selectedVariant }) {
  const swatch = selectedVariant?.relatedProductsSwatches?.[0];

  if (!swatch) return null;

  const openDetails = () => {
    document.dispatchEvent(
      new CustomEvent("markup-modal:open", {
        bubbles: true,
        detail: { target: "swatch-details-modal" },
      }),
    );
  };

  const strings = window.localeStrings.product;
  const price = formatSwatchPrice(swatch.variants?.[0]?.price);

  const label = () => {
    if (!isRugSwatch(swatch)) return strings.request_swatch;
    // Rug samples are priced, but a swatch product missing its variant price
    // still needs a button.
    if (!price) return strings.request_rug_sample;

    return strings.request_rug_sample_price.replace("[price]", price);
  };

  return (
    <button
      type="button"
      className="button button--small-round button--full main-product-details__swatch-button product-options__request-swatch"
      onClick={openDetails}
    >
      <Swatch />
      {label()}
    </button>
  );
}
